// we write all api calls here

import { endpoints } from "@app/api/apis";
import axios from "axios";
import { getApplicationId } from "@app/screens/FetchPortfolio/utils";


export const fetchBankAccounts = async (payload: {
    applicationId: string;
}) => {

  const applicationId = await getApplicationId(payload.applicationId);

  const response = await axios.get(endpoints.bav + applicationId);
  return response.data;
};

export const fetchBankAccountsFromApplication = async (payload: {
  applicationId: string;
}) => {
  const applicationId = await getApplicationId(payload.applicationId);

  const response = await axios.get(endpoints.getBankAccountDetailsForLoanServicingApplication + applicationId);
  return response.data;
};


// on bank verify clicked


export const verifyBankAccount = async (payload: {
    applicationId: string;
    bankAccountNumber: string;
    bankIfscCode: string;
}) => {

  const applicationId = await getApplicationId(payload.applicationId);


  // pick implementation from BavVerifyAction

  const response = await axios.post(endpoints.bavVerify, {
    applicationId,
    bankAccountDetails: {
      bankAccountNumber: payload.bankAccountNumber,
      bankIfscCode: payload.bankIfscCode,
    },
  }, {
    handle500Here: true 
  });

  return response;

}


export const getStepper = async (payload: {
  applicationId: string;
}) => {

  const applicationId = await getApplicationId(payload.applicationId);
  const response = await axios.post(endpoints.getStepper, {
    applicationId,
  });
  return response.data;
}
